import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const useSlideEnterAnimation = ({
  selector = "[data-transition='slide-enter'], [data-transition='slide-enter-child'] > *",
  dependencies = [],
  shouldScale = true,
  shouldMove = true,
  shouldFade = true,
} = {}) => {
  useGSAP(
    (_context, _contextSafe) => {
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      gsap.config({
        autoSleep: 60,
      });
      gsap.set(selector, {
        y: shouldMove ? 50 : 0,
        opacity: shouldFade ? 0 : 1,
        scale: shouldScale ? 0.95 : 1,
        willChange: "transform",
      });
      ScrollTrigger.batch(selector, {
        start: "top 100%+=100px",
        end: "top 100%-=100px",
        invalidateOnRefresh: true,
        onLeave: (elements) => {
          elements.forEach((el, index) => {
            const isChild =
              el.parentElement && el.parentElement.getAttribute("data-transition") === "slide-enter-child";

            gsap.to(el, {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: reduceMotion ? 0 : isChild ? 0.3 : 0.5,
              delay: isChild ? index * 0.05 : 0,
              overwrite: true,
            });
          });
        },
        onLeaveBack: (elements) => {
          elements.forEach((el) => {
            gsap.set(el, {
              y: shouldMove ? 50 : 0,
              opacity: shouldFade ? 0 : 1,
              scale: shouldScale ? 0.95 : 1,
            });
          });
        },
      });
      ScrollTrigger.config({ ignoreMobileResize: true });
    },
    { dependencies }
  );
};
